import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService, UserService } from "../../../../auth/service";
import * as moment from "moment";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AssetsService } from "../../assets.service";
import Italian from "flatpickr/dist/l10n/it";
import { FlatpickrOptions } from "ng2-flatpickr";
import { IAsset, IAssetAssign } from "../../models/assets";

@Component({
  selector: "app-assets-associate-modal",
  templateUrl: "./assets-associate-modal.component.html",
  styleUrls: ["./assets-associate-modal.component.scss"],
})
export class AssetsAssociateModalComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @Output() onAssociate: EventEmitter<any> = new EventEmitter();
  @ViewChild("associateAsset") associateAsset: ElementRef;
  @Input() assetID: number = 0;
  @Input() employee: any = {};
  @Input() isFromFutureEmployeeList: boolean = false;
  public formGroup: FormGroup;
  public employees: any = [];
  public basicDateSend: FlatpickrOptions;
  public assetList: IAsset[] = [];
  public showErrors: boolean = false;

  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _formBuilder: FormBuilder,
    public _assetsService: AssetsService,
    public _userService: UserService,
  ) {
    this.formGroup = this._formBuilder.group({
      description: new FormControl("", [Validators.maxLength(255)]),
      employee: new FormControl("", [Validators.required]),
      date: new FormControl(moment(), [Validators.required]),
      location: new FormControl("", [Validators.maxLength(255)]),
      assetId: new FormControl(null, [Validators.required]),
    });
    this.basicDateSend = {
      altFormat: "d/m/Y",
      locale: Italian.it,
      altInput: true,
      utc: true,
      defaultDate: "today",
      disableMobile: true,
    };
  }

  async ngOnInit() {
    //Se la modal viene aperta da futuri dipendenti lista carichiamo la lista di tutti gli asset e la lista soltanto di dipendenti futuri
    if (this.isFromFutureEmployeeList) {
      this.assetList = await this._assetsService.getAllAssets();
      this.assetList = this.assetList.filter((asset) => asset.inMaintenance === 0 && asset.assigned === 0);
      this.employees = await this._userService.getFutureEmployees();
      this.formGroup.patchValue({
        employee: this.employee.hash,
        location: this.employee.working_city,
      });
      //Se la modal NON viene aperta da futuri dipendenti lista togliamo il validator su assetId del formGroup e carichiamo la lista dei dipendenti
    } else {
      this.formGroup.get("assetId").clearValidators();
      this.employees = await this._userService.getActiveUsers();
    }
    setTimeout(() => this.openModal());
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  openModal() {
    this._modalService.open(this.associateAsset, {
      centered: true,
      size: "lg",
    });
  }

  closeModal() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this.callbackFn.emit();
    this.basicDateSend = {
      altFormat: "d/m/Y",
      locale: Italian.it,
      altInput: true,
      utc: true,
      defaultDate: "today",
      disableMobile: true,
    };
  }

  async saveAssociate() {
    if (!this._authenticationService.hasCapability("manage_assign_asset")) {
      window.history.back();
      return false;
    }
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }
    if (!this.isFromFutureEmployeeList) {
      if (this.assetID < 1) {
        await this._utilService.showSWALError({ text: "ERROR_ASSOCIATE_ASSET" });
        return false;
      }
      this.formGroup.value.assetId = this.assetID;
    }
    const data: IAssetAssign = {
      asset_id: this.formGroup.value.assetId,
      user_hash: this.formGroup.value.employee,
      start_date: moment(this.formGroup.value.date[0]).format("YYYY-MM-DD"),
      note: this.formGroup.value.description,
      location: this.formGroup.value.location,
    };
    this._utilService.showLoading();
    await this._assetsService
      .assignAsset(data)
      .then(async () => {
        this._utilService.hideLoading();
        this.onAssociate.emit();
        await this.closeModal();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_ASSOCIATE_ASSET" });
      })
      .catch((e) => {
        if (e == "Asset in maintenance") {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ASSET_IN_MAINTENANCE" });
        } else {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_ASSOCIATE_ASSET" });
        }
      });
  }
}
